import { userHasRight } from "../../../framework";
import * as z from "../../../framework";
import { emptyFn } from "../../core/util";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_EURL from "../templates/K_EURL";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface EURLOptions extends ComponentOptions {
    title?: string;         // Name of the field (appears to the left of the URL)
    cf?: boolean;           // Indicates whether this is a custom field
    classes?: string;       // String of space-delimited CSS classes
    bsc?: string;           // Some styling
    checkTitle?: string;    // Text that appears when you hover over checkmark
    cancelTitle?: string;   // Text that appears when you hover over cancel button
    args?: any;             // Will contain this field's name and the table it comes from
    requiredRight?: string;
    rightLocked?: boolean;
}

export class EURL extends TemplateComponent {

    options: EURLOptions & RightLockable;

    constructor(options: EURLOptions) {
        super(K_EURL, options);
    }

    preRender() {
        const me = this;
        let options = this.options;
        options.title = options.args.field.FieldName;
        options.bindValue = buildDataBindSyntax(options.bindValue, "url");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.cf = options.cf || false;
        options.checkTitle = z.ll(options.checkTitle) || z.ll("Confirm");
        options.cancelTitle = z.ll(options.cancelTitle) || z.ll("Cancel");

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }
    }

    create() {
        let me = this;
        let udfFieldName,
            bindData;
        let title = $(`#${me.id}_title`);               // The gray label to the left
        let url = $(`#${me.id}_url`);                   // The blue thing that looks like a link
        let titleTB = $(`#${me.id}_titleTB`);           // The text box to the left in the "edit" view
        let urlTB = $(`#${me.id}_urlTB`);               // The text box to the right in the "edit" view
        let pencilIcon = $(`#${me.id}_pencilIcon`);     // Button to edit the URL
        let checkIcon = $(`#${me.id}_checkIcon`);       // Button to save change
        let cancelIcon = $(`#${me.id}_cancelIcon`);     // Button to discard change
        let buttonsSpan = $(`#${me.id}_CheckCancel`);   // Container for check and cancel buttons
        let displayView = [title, url, pencilIcon];     // What is shown when you are NOT editing
        let editView = [titleTB, urlTB, buttonsSpan];   // What is shown when you are editing the URL
        let hidden = [];                                // Elements shown on some EURLs but not others
        let cf = $(`#${me.id}_CF`);                     // C that says it is a custom field

        /*** Setup actions ***/

        if (me.options.cf) {
            displayView.push(cf);
        } else {
            hidden.push(cf);
        }
        if (me.options.args.tableName == "OrderSegment" && !IsDigit(me.id[0])) {
            hidden.push(pencilIcon);
            displayView.remove(pencilIcon);
        } else {
            pencilIcon.tie("click", () => {
                SetDefinedFields();

                EditView();
            });
        }

        // Save entered URL and title when the check is clicked
        checkIcon.tie("click", () => {
            if (!IsValidAttempt()) {
                return;
            }

            SaveChanges();
            DisplayView();
        });

        // Discard the changes when the X is clicked
        cancelIcon.tie("click", () => {
            DisplayView();
        });

        // Open the URL in a new tab when the URL is clicked
        url.tie("click", function () {
            SetDefinedFields();
        });

        HideHiddenElements();

        DisplayView();

        /*** Functions for manipulating user interface ***/

        /**
         * Shows the "Display View" to the user, with a clickable link
         * and a pencil to edit the values.
         */
        function DisplayView() {

            pencilIcon.removeClass("hidden");
            editView.forEach(e => {
                e.attr("hidden", "true");
            });
            displayView.forEach(e => {
                e.removeAttr("hidden");
            });

        }

        /**
         * Shows the "Edit View" to the user - text boxes, and a
         * check mark to save or an X to cancel
         */
        function EditView() {

            let combinedURL: string = bindData.get(udfFieldName);
            let urlDisplay: string = SplitUDFValue(combinedURL, true);
            let urlGuts: string = SplitUDFValue(combinedURL, false);

            // Set the text in the 'Title' text box
            if (urlDisplay.trim() === "" || urlDisplay === "---") {
                titleTB.attr("placeholder", z.ll("Title"));
                titleTB.val("");
            } else {
                titleTB.val(urlDisplay);
            }

            // Set the text in the 'URL' text box
            if (urlGuts.trim() === "") {
                urlTB.attr("placeholder", z.ll("URL"));
                urlTB.val("");
            } else {
                urlTB.val(urlGuts);
            }

            // Make the appropriate GUI elements visible and hide the ones we don't need
            pencilIcon.addClass("hidden");
            displayView.forEach(e => {
                e.attr("hidden", "true");
            });
            editView.forEach(e => {
                e.removeAttr("hidden");
            });
        }

        /**
         * Hides all the elements that have been explicitly marked as not
         * relevant to this particular EURL
         */
        function HideHiddenElements() {
            hidden.forEach(e => {
                e.attr("hidden", "true");
            });

            if (hidden.indexOf(pencilIcon) > -1) {
                pencilIcon.addClass("hidden");
            }
        }

        /**
         * Stores the user-input data from the textboxes into the bindData
         * that is linked to this EURL.
         */
        function SaveChanges() {

            let urlDisplaysAs: string = titleTB.val().trim();
            let urlLinksTo: string = urlTB.val().trim();
            let combined = `${urlDisplaysAs}|${urlLinksTo}`;

            if (urlDisplaysAs === "" && urlLinksTo == "") {
                combined = null;
            }

            // Update the bind data object, which should hopefully update the GUI elements!
            bindData.set(udfFieldName, combined);

            UpdateLink(urlLinksTo);
        }

        /**
         * Updates the 'href' and 'target' attributes of the link if appropriate.
         * Removes them if the URL is empty.
         * @param urlLinksTo The URL in question
         */
        function UpdateLink(urlLinksTo) {
            // User entered an actual URL
            if (urlLinksTo && urlLinksTo != "") {
                url.attr("href", urlLinksTo);
                url.attr("target", "_blank");
            } else {
                url.removeAttr("href");
                url.removeAttr("target");
            }
        }

        /*** Helper functions, input validation and parsing, etc ***/

        /**
         * Get the observable object (bindData) that will make it so Ajax calls
         * are automatically changed whenever the user edits this URL.
         */
        function SetDefinedFields() {
            let selector = `#${me.id}_url`;
            bindData = $(selector).data("bindData");
            udfFieldName = SplitIdToField(me.id);

            let urlLinksTo = SplitUDFValue(bindData.get(udfFieldName), false);
            UpdateLink(urlLinksTo);
        }

        function NumberSplitIdToField(id: string) {
            return id.slice(id.indexOf("_", 5) + 1);
        }

        function SplitIdToField(id: string) {
            if (parseInt(id[0], 10) >= 0) {
                return NumberSplitIdToField(id);
            }
            return id.slice(id.indexOf("_") + 1);
        }

        function SplitUDFValue(udfString: string, isTitle: boolean) {
            // UDF is stored as: title|url
            try {
                // A URL cannot legally have a pipe in it, so we know that the
                // last occurrence of a pipe in the string is the delimiter
                let udfArr = udfString.splitOnLastInstanceOf("|");
                return isTitle ? udfArr[0] : udfArr[1];
            } catch (e) {
                return "";
            }
        }

        function IsDigit(char: string) {
            return !isNaN(parseInt(char, 10));
        }

        /**
         * Validates that both the URL title and the URL link are valid
         * (both must be empty or both must be valid)
         * If any is invalid, the invalid fields are highlighted red to
         * draw the user's attention.
         * @returns true if valid, false if invalid
         */
        function IsValidAttempt() {

            urlTB.removeClass("eurl-invalid");
            titleTB.removeClass("eurl-invalid");

            let urlValue = urlTB.val().trim();
            let titleValue = titleTB.val().trim();
            let valid = true;

            // Both can be empty
            if (titleValue == "" && urlValue == "") {
                return valid;
            }

            // Check URL validity
            if (urlValue.indexOf("|") != -1) {
                urlTB.addClass("eurl-invalid");
                valid = false;
            }

            // Check that both are filled out
            if (titleValue == "" /* && urlValue != "" */) {
                titleTB.addClass("eurl-invalid");
                valid = false;
            }
            if (urlValue == "" /* && titleValue != ""*/) {
                urlTB.addClass("eurl-invalid");
                valid = false;
            }

            return valid;
        }
    }
}
